import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Función para la validación personalizada del número de teléfono
export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const phone = control.value;

    // Expresión regular para validar:
    // 1. Comienza con 9
    // 2. Al menos 9 dígitos
    // 3. No es una secuencia repetida de dígitos (por ejemplo, "000000000", "111111111", etc.)
    const phonePattern = /^(?!(\d)\1{6,})\d{6,}$/;

    // Si el valor no coincide con el patrón, es inválido
    if (phone && !phonePattern.test(phone)) {
      return { invalidPhoneNumber: true };
    }

    // Si la validación es exitosa, no retornamos errores
    return null;
  };
}
